@@ -1,80 +0,0 @@
<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <div class="w-full h-full my-auto">
        <calcolatore :disclaimer="page.disclaimer">
          <section class="mb-4">
            <h1
              class=" sm:text-left text-title-sm sm:text-title-md text-center"
            >
              <span class="text-outline" v-text="page.titolo1" />
              <span v-text="page.titolo2" />
              <span class="text-outline" v-text="page.titolo3" />
            </h1>
            <div class="sm:text-left prose text-center">
              <p
                v-html="
                  `Seleziona il pacchetto che più ti interessa e scopri quanto puoi guadagnare. <b>Hai sempre una remunerazione, senza vincolare somme</b>.`
                "
              ></p>
            </div>
          </section>
        </calcolatore>
      </div>
    </div>
    <!-- <div class="parallax absolute inset-0 flex items-center justify-center">
      <img class="max-h-96 " src="/img/bubble.png" />
    </div> -->
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import Calcolatore from "../../components/calcolatore/Calcolatore.vue";

export default {
  components: { Calcolatore },
  data: () => ({
    megaPromoDate: new Date()
  }),
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  },
  async mounted() {
    try {
      const response = await this.axios.get(
        `${process.env.VUE_APP_PLUGIN_GENERAL_API}/client-settings`
      );

      this.megaPromoDate = new Date(
        response.data.data.MegaPromoRequestableUntil.slice(0, -1)
      );

      this.megaPromoDate = this.megaPromoDate.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    } catch (error) {
      error;
    }
  }
};
</script>
<route>
{
  "name": "Quanto controcorrente sei?",
  "meta": {
      "order": 3,
      "label": "Quanto sei Controcorrente?",
      "hideMenu": {
        "inline": true,
        "main" : true
      },
      "hideAsChild": {
        "inline": true,
        "main" : true
      }
  }
}
</route>
